<template>
  <div class="captcha-input">
    <InputField
      :model-value="modelValue"
      :placeholder="placeholder"
      :height="height"
      :class="['captcha-input__input', inputClass]"
      @update:model-value="handleInput"
    />
    <Button
      variant="text-purple"
      :disabled="isSend"
      :class="['captcha-input__button', buttonClass, { 'captcha-input__button--disabled': isSend }]"
      @click.stop="handleSendCode"
    >
      <slot name="button-text">
        {{ isSend ? buttonTextResend(times) : buttonText }}
      </slot>
    </Button>
  </div>
</template>

<script lang="ts" setup>
import { Button } from '@rendora/design/components/button/index';
import { InputField } from '@rendora/design/components/input/index';

interface Props {
  modelValue?: string;
  placeholder?: string;
  height?: number;
  isSend?: boolean;
  times?: number;
  inputClass?: string;
  buttonClass?: string;
  buttonText?: string;
  buttonTextResend?: (time: number) => string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
  placeholder: '请输入验证码',
  height: 44,
  isSend: false,
  times: 0,
  inputClass: '',
  buttonClass: '',
  buttonText: '获取验证码',
  buttonTextResend: (time: number) => `重新获取 (${time}s)`,
});

const emits = defineEmits<{
  'update:modelValue': [value: string];
  'send-code': [];
}>();

const handleInput = (value: string | number) => {
  emits('update:modelValue', String(value));
};

const handleSendCode = () => {
  emits('send-code');
};
</script>

<style lang="scss" scoped>
@use '../../styles/mixins.scss' as *;
.captcha-input {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.captcha-input__input {
  flex: 1;

  @include tablet-up {
    padding-right: 120px;
  }

  @include mobile {
    padding-right: responsive-size(120px);
  }
}

.captcha-input__button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
  z-index: 1;
  transition: none;

  @include tablet-up {
    right: 4px;
    padding: 0 11px;
  }

  @include mobile {
    right: responsive-size(4px);
    padding: 0px responsive-size(11px);
  }

  &:hover {
    background-color: var(--x-purple-1);
  }

  &:active:not(:disabled) {
    transform: translateY(-50%) scale(0.97) !important;
  }
}

.captcha-input__button--disabled {
  background-color: var(--x-purple-1);
}
</style>
